import React from 'react';
import Container from './ui/Container';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

export default function CategoryOverview({ categories }) {
  return (
    <section className="py-20 bg-slate-50 border-y border-slate-200">
      <Container>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {categories.map((cat, idx) => (
            <motion.a
              key={cat.id}
              href={`#${cat.id}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: idx * 0.1 }}
              className="group block p-10 bg-white rounded-2xl border border-slate-200 shadow-sm hover:shadow-xl hover:border-slate-300 transition-all duration-500"
            >
              <div className="flex items-center justify-between mb-6">
                <div className="p-3 bg-blue-50 rounded-xl group-hover:bg-blue-600 group-hover:text-white transition-colors duration-500">
                  <SafeIcon 
                    icon={cat.id === 'automation' ? FiIcons.FiCpu : FiIcons.FiBarChart2} 
                    className="w-6 h-6" 
                  />
                </div>
                <SafeIcon 
                  icon={FiIcons.FiArrowRight} 
                  className="w-5 h-5 text-slate-300 group-hover:text-blue-600 group-hover:translate-x-1 transition-all" 
                />
              </div>
              <h3 className="text-2xl font-bold text-slate-900 mb-4">
                {cat.title}
              </h3>
              <p className="text-slate-600 mb-8 leading-relaxed">
                {cat.description}
              </p>
              <span className="inline-flex items-center text-sm font-bold text-blue-600">
                Explore {cat.demos.length} Solutions
              </span>
            </motion.a>
          ))}
        </div>
      </Container>
    </section>
  );
}